import React from 'react';
import Typography from '@material-ui/core/Typography';

const RequiredInfoText = (props) => <Typography align={ props.align } color='textSecondary'
                                                style={ { fontSize: '12px' } }>(* Required fields)</Typography>;

export default RequiredInfoText;